import { BUTTON_VARIANTS } from '@/CommonComponents/constants'
import { type IAvailableIcons } from './Icon'
import Icon from '@/CommonComponents/Icon'
import MUIButton from '@mui/material/Button'
import React from 'react'
import type { SxProps } from '@mui/material/styles'

const MUI_BUTTON_VARIANTS = {
  [BUTTON_VARIANTS.CONTAINED]: 'contained',
  [BUTTON_VARIANTS.OUTLINED]: 'outlined',
  [BUTTON_VARIANTS.TEXT]: 'text',
} as const

interface IButtonProps {
  variant?: 'contained' | 'outlined' | 'text'
  label?: string
  sx?: SxProps
  disabled?: boolean
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  size?: 'x-small' | 'small' | 'medium' | 'large'
  icon?: IAvailableIcons
  color?: 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
  lowercase?: boolean
}

const X_SMALL_BUTTON_SIZE = {
  fontSize: '0.7rem',
  padding: '2px 8px',
  minWidth: 'auto',
}

export default function Button({
  disabled = false,
  icon,
  label,
  onClick,
  size,
  sx = {},
  color = 'secondary',
  variant = 'outlined',
  lowercase,
}: IButtonProps) {
  return (
    <MUIButton
      variant={MUI_BUTTON_VARIANTS[variant]}
      color={color}
      sx={{
        ...(lowercase ? { textTransform: 'none' } : {}),
        ...(size === 'x-small' ? X_SMALL_BUTTON_SIZE : {}),
        ...(sx ?? {}),
      }}
      onClick={onClick}
      size={size === 'x-small' ? 'small' : size}
      disabled={disabled}
    >
      {' '}
      {icon && <Icon icon={icon} sx={{ mr: 1 }} />}
      {label}{' '}
    </MUIButton>
  )
}
